<div *ngIf="estudiante" class="estudiante-info">
  <header>
    <div class="title-group">
      <h1>{{ isNew ? 'Registrar estudiante' : 'Detalle estudiante' }}</h1>
    </div>
  </header>
  <div class="content-columns">
    <div class="estudiante-data">
      <!-- Secondary header for estudiante-data section -->
      <div class="estudiante-data-header">
        <div class="nro-libreta">
          <i class="fas fa-hashtag"></i> {{ estudiante.nroLibreta || 'Nuevo estudiante' }}
        </div>
      </div>
      
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      
      <!-- Basic Information -->
      <div class="form-row">
        <div class="info required-field">
          <label>Apellido:</label>
          <input type="text" [(ngModel)]="estudiante.apellido" [readonly]="!isEditMode" />
        </div>
        <div class="info required-field">
          <label>Nombre:</label>
          <input type="text" [(ngModel)]="estudiante.nombre" [readonly]="!isEditMode" />
        </div>
      </div>

      <div class="form-row">
        <div class="info date-field">
          <label>Fecha de Nacimiento:</label>
          <input type="date" [(ngModel)]="estudiante.fcNacimiento" [readonly]="!isEditMode" />
        </div>
        <div class="info date-field">
          <label>Fecha de Inicio:</label>
          <input type="date" [(ngModel)]="estudiante.fcInicio" [readonly]="!isEditMode" />
        </div>
      </div>

      <div class="form-row">
        <div class="info documento-field">
          <label>Documento:</label>
          <input type="text" [(ngModel)]="estudiante.documento" [readonly]="!isEditMode" />
        </div>
        <div class="info">
          <label>Nacionalidad:</label>
          <input type="text" [(ngModel)]="estudiante.nacionalidad" [readonly]="!isEditMode" />
        </div>
      </div>

      <!-- Additional Personal Information -->
      <div class="info">
        <label>Ocupación:</label>
        <input type="text" [(ngModel)]="estudiante.ocupacion" [readonly]="!isEditMode" />
      </div>

      <!-- Address Information -->
      <div class="info">
        <label>Domicilio:</label>
        <input type="text" [(ngModel)]="estudiante.domicilio" [readonly]="!isEditMode" />
      </div>

      <div class="form-row">
        <div class="info">
          <label>Localidad:</label>
          <input type="text" [(ngModel)]="estudiante.localidad" [readonly]="!isEditMode" />
        </div>
        <div class="info">
          <label>Provincia:</label>
          <input type="text" [(ngModel)]="estudiante.provincia" [readonly]="!isEditMode" />
        </div>
      </div>

      <!-- Contact Information -->
      <div class="form-row">
        <div class="info">
          <label>Teléfono:</label>
          <input type="text" [(ngModel)]="estudiante.telefono" [readonly]="!isEditMode" />
        </div>
        <div class="info">
          <label>Email:</label>
          <input type="email" [(ngModel)]="estudiante.email" [readonly]="!isEditMode" />
        </div>
      </div>

      <!-- Training Information -->
      <div class="info">
        <label>Instructor:</label>
        <select *ngIf="isEditMode" [(ngModel)]="estudiante.idInstructor" (ngModelChange)="onInstructorChange($event)">
          <option [ngValue]="null">Seleccione instructor</option>
          <option *ngFor="let instructor of instructores" [ngValue]="instructor.id">
            {{ instructor.apellido }}, {{ instructor.nombre }}
          </option>
        </select>
        <div *ngIf="!isEditMode" class="readonly-instructor">
          {{ getInstructorNombre() || 'Sin instructor' }}
        </div>
      </div>

      <div class="info">
        <label>Centro de Entrenamiento:</label>
        <select *ngIf="isEditMode" [(ngModel)]="estudiante.idCentroEntrenamiento" (ngModelChange)="onCentroChange($event)">
          <option [ngValue]="null">Seleccione centro</option>
          <option *ngFor="let centro of centros" [ngValue]="centro.id">
            {{ centro.nombre }}
          </option>
        </select>
        <div *ngIf="!isEditMode" class="readonly-centro">
          {{ getCentroNombre() || 'Sin centro' }}
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="buttons-container">
        <button *ngIf="!isEditMode" 
                type="button" 
                class="edit-button" 
                (click)="toggleEditMode()"
                [title]="isNew ? 'Cancelar registro' : 'Editar estudiante'">
          <i class="fas fa-pencil-alt"></i>
          <span>{{ isNew ? 'Cancelar' : 'Editar' }}</span>
        </button>
        
        <button *ngIf="isEditMode" 
                type="button"
                class="edit-button cancel-btn"
                (click)="toggleEditMode()"
                title="Cancelar edición">
          <i class="fas fa-times"></i>
          <span>Cancelar</span>
        </button>
        
        <button type="button" 
                [disabled]="!isEditMode" 
                (click)="saveChanges()"
                class="save-button"
                [title]="isNew ? 'Registrar estudiante' : 'Guardar cambios'">
          <i class="fas fa-save"></i>
          <span>{{ isNew ? 'Registrar' : 'Guardar' }}</span>
        </button>
      </div>
    </div>

    <!-- Examenes Section -->
    <div class="examenes-list" *ngIf="!isNew">
      <app-examenes-list 
        [nroLibreta]="estudiante.nroLibreta" 
        [estudiante]="estudiante" 
        [isEstudianteEditMode]="isEditMode">
      </app-examenes-list>
    </div>
    
    <div class="examenes-list" *ngIf="isNew">
      <div class="new-student-info">
        <h3>Información sobre exámenes</h3>
        <p>Los exámenes del estudiante aparecerán aquí una vez que sea registrado.</p>
      </div>
    </div>
  </div>
</div>